import {Badge, ColourSolid, ListItem} from "@twigsby/frontend-framework";
import React from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";

type HarmonySearchResultsType = {
    selectedCallback: (id: string, type: string) => void;
}

const HarmonySearchResults = (props: HarmonySearchResultsType) => {
    const { harmonyCodes } = useForwardingBatchProvider();

    return (
        <div>
            {harmonyCodes.map((item: any, index: number) =>
                <ListItem
                    key={`commodityEntry${index}`}
                    hideArrow={item.type === 'Commodity'}
                    onClick={() => props.selectedCallback(item.id, item.type)}
                    addonLeft={item.type === 'Commodity' ? <Badge colour={ColourSolid.Success} /> : undefined}
                    title={`${item.title}`}
                    description={item.type === 'Commodity' ? item.id : ''}
                />
            )}
        </div>
    )
}

export { HarmonySearchResults }
